import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Loader from "components/Loader";

// const YearMonthFilters = lazy(() =>
//   import("pages/FiltersSidebar/YearMonthFilters")
// );



const MTPPublicInvestmentPlanFilters = lazy(() => import("pages/MTPPublicInvestmentPlan/filters"));
const InvestmentStreamsFilters = lazy(() => import("pages/InvestmentStreams/filters"));
const StateSectoralPipelinesFilters = lazy(() => import("pages/StateSectoralPipelines/filters"));
const StateSingleProjectPipelineFilters = lazy(() => import("pages/StateSingleProjectPipeline/filters"));
const ExpertEvaluationOfProjectsAndProgramsFilters = lazy(() => import("pages/ExpertEvaluationOfProjectsAndPrograms/filters"));
const PublicInvestmentProjectDetailsFilters = lazy(() => import("pages/PublicInvestmentProjectDetails/filters"));

const MTPPublicInvestmentPlanFiltersPopups = lazy(() => import("pages/MTPPublicInvestmentPlan/filterspopups"));
const InvestmentStreamsFiltersPopups = lazy(() => import("pages/InvestmentStreams/filterspopups"));

export default function SideBar() {
  return (
    <Suspense fallback={<Loader />}>
      <div className="p-2">

      <Switch>
          <Route exact path="/mtp">
            <MTPPublicInvestmentPlanFiltersPopups />
          </Route>
          <Route path="/investmentStreams">
            <MTPPublicInvestmentPlanFiltersPopups /> {/* InvestmentStreamsFiltersPopups */}
          </Route>
          <Route path="/sp">
            <MTPPublicInvestmentPlanFiltersPopups /> {/* StateSectoralPipelinesFiltersPopups */}
          </Route>
          <Route path="/spp">
            <MTPPublicInvestmentPlanFiltersPopups /> {/* StateSectoralPipelinesFiltersPopups */}
          </Route>
          <Route path="/expertEvaluation">
            <MTPPublicInvestmentPlanFiltersPopups /> {/* StateSectoralPipelinesFiltersPopups */}
          </Route>
          <Route path="/pipDetails">
            <MTPPublicInvestmentPlanFiltersPopups /> {/* StateSectoralPipelinesFiltersPopups */}
          </Route>
        </Switch>    

        {/* <YearMonthFilters /> */}
        
        <Switch>
          <Route exact path="/mtp">
            <MTPPublicInvestmentPlanFilters />
          </Route>
          <Route path="/investmentStreams">
            <InvestmentStreamsFilters /> {/* InvestmentStreamsFilters */}
          </Route>
          <Route path="/sp">
            <StateSectoralPipelinesFilters /> {/* InvestmentStreamsFilters */}
          </Route>
          <Route path="/spp">
            <StateSingleProjectPipelineFilters /> {/* InvestmentStreamsFilters */}
          </Route>
          <Route path="/expertEvaluation">
            <ExpertEvaluationOfProjectsAndProgramsFilters /> {/* InvestmentStreamsFilters */}
          </Route>
          <Route path="/pipDetails">
            <PublicInvestmentProjectDetailsFilters /> {/* InvestmentStreamsFilters */}
          </Route>
        </Switch>

      </div>
    </Suspense>
  );
}
